import { Alert } from 'antd';

type ErrorBoxProps = {
  title: string;
  description?: string;
};

export const ErrorBox = ({ title, description, ...props }: ErrorBoxProps) => (
  <Alert
    message={title}
    description={description}
    type="error"
    showIcon
    {...props}
  />
);
